import React, { useEffect, useContext, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Table1 from "./Tabels/table1";
import Table2 from "./Tabels/table2";
import Table3 from "./Tabels/table3";
import Table4 from "./Tabels/table4";
import Table5 from "./Tabels/table5";
import Table6 from "./Tabels/table6";
import Table7 from "./Tabels/table7";
import {
    Grid,
    TableCell,
} from "@material-ui/core";
export default function ExecutiveDashboard(props) {

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.primary.main,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);
    const methods = useForm({
        mode: "onChange",
        validateCriteriaMode: "all",
        submitFocusError: true,
        // defaultValues,
    })


    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Table1 item={props.executiveData} />
                </Grid>
                {/* <Grid item xs={12} sm={4}>
                    <Table2 item={props.executiveData} />
                </Grid> */}
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Table3 item={props.executiveData} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Table4 item={props.executiveData} />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Table5 item={props.executiveData} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    {/* <Table6 /> */}
                    <Table7 item={props.executiveData} />
                </Grid>
            </Grid>
            {/* <Table7 item={props.executiveData} /> */}
        </>
    );
}



